import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import EditorCloseIcon from '@atlaskit/icon/core/cross';

interface CloseButtonProps {
	onClose?(): void;
}

// React 19 prefers ref as a prop, forwardRef remains supported for backward compatibility
export const CloseButton: React.ForwardRefExoticComponent<
	CloseButtonProps & React.RefAttributes<HTMLButtonElement | null>
> = React.forwardRef<HTMLButtonElement | null, CloseButtonProps>(({ onClose }, ref) => {
	return (
		<IconButton
			testId="sidebar-main-close-btn"
			label="Close"
			onClick={onClose}
			icon={EditorCloseIcon}
			ref={ref}
		/>
	);
});

CloseButton.displayName = 'CloseButton';
